import { Modal, Table, Text } from '@mantine/core';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CampaignReport from "../../api/CampaignReport";
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import { VisiLoader } from "../../components/GeneralComponent/GeneralComponent";

interface VariationAd {
  ad_id: string | number;
  ad_name: string;
  adset?: string;
  campaign_name?: string;
  traffic_source?: string;
  conversions: number;
  [key: string]: any;
}

interface VariationAdsModalProps {
  isOpen: boolean;
  onClose: () => void;
  // payload coming from CreateReport click
  payload: {
    variationId?: string; // variation display id/name
    variationName?: string;
    campaign_goal?: string;
    campaign_goal_type?: string;
    campaign_id?: string | number;
    report_id?: string;
    test_id?: string | number;
    time_value?: string | number;
  } | null;
}

export function VariationAdsModal({
  isOpen,
  onClose,
  payload,
}: VariationAdsModalProps) {
  const navigate = useNavigate();
  const [adsData, setAdsData] = useState<VariationAd[]>([]);
  const [isVisiLoaderVisible, setIsVisiLoaderVisible] = useState(false);

  useEffect(() => {
    if (isOpen && payload) {
      fetchVariationAdsData();
    }
  }, [isOpen, payload]);

  const fetchVariationAdsData = () => {
    setIsVisiLoaderVisible(true);
    const body: any = {
      variation_id: payload?.test_id || payload?.variationId || '',
      report_id: payload?.report_id || '',
      campaign_id: payload?.campaign_id || '',
      campaign_goal: payload?.campaign_goal || '',
      campaign_goal_type: payload?.campaign_goal_type || '',
      time_value: payload?.time_value || ''
    };

    CampaignReport.getVariationAdsData(body)
    .then(response => {
      if (response.ok) return response.json();

      if (response.status === 401 || response.status === 400) {
        navigate('/logout');
      }
    })
    .then(data => {
      if (data?.status === 1) {
        setAdsData(data.data.ads || []);
      } else {
        setAdsData([]);
      }
    })
    .finally(() => {
      setIsVisiLoaderVisible(false);
    });
  };

  return (
    <Modal.Root opened={isOpen} onClose={onClose} size="80%" trapFocus={false}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>
              <Text weight={500} size="lg">
              Variation Details: {payload?.variationName || payload?.variationId || ''}
            </Text>
          </Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>
          <VisiLoader VisiLoaderVisible={isVisiLoaderVisible}/>
          
          {adsData && adsData.length > 0 ? (
            <SimpleBar forceVisible="x" autoHide={false} style={{ paddingBottom: '12px' }}>
              <Table striped highlightOnHover withBorder fontSize="xs" withColumnBorders>
                <thead>
                  <tr>
                    <th>Traffic Source</th>
                    <th>Camapaign Name</th>
                    <th>Ad Set / Group Name</th>
                    <th>Ad Name</th>
                    <th>Conversions</th>
                  </tr>
                </thead>
                <tbody>
                  {adsData.map((ad, index) => (
                    <tr key={index}>
                      <td>{ad.traffic_source || '-'}</td>
                      <td>{ad.campaign_name || '-'}</td>
                      <td>{ad.adset || '-'}</td>
                      <td>{ad.ad_name || '-'}</td>
                      <td>{ad.conversions || 0}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </SimpleBar>
          ) : isVisiLoaderVisible ? (
            <Text color="dimmed" align="center" py="xl">
              Loading ads data...
            </Text>
          ) : (
            <Text color="dimmed" align="center" py="xl">
              No ads data available for this variation
            </Text>
          )}
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
}